import { createProductFirstFiltersRequest } from "@faire/deprecated-retailer-visitor-shared/categories/createRequests/createProductFirstFiltersRequest";
import fetchProductCatNavFilters from "@faire/web-api--source/endpoints/www/api/v2/search/products/cat-nav/filters/post";
import { IGetProductFilterSectionInfoResponse } from "@faire/web-api--source/indigofair/data/IGetProductFilterSectionInfoResponse";
import { ISearchRequestReferrer } from "@faire/web-api--source/indigofair/data/ISearchRequestReferrer";

export const fetchFiltersResults = async (
  {
    navigationPath,
    filterKeys,
    requestReferrer,
  }: {
    navigationPath: string;
    filterKeys: string[];
    requestReferrer: ISearchRequestReferrer;
  },
  {
    signal,
  }: {
    signal: AbortSignal | undefined;
  }
): Promise<IGetProductFilterSectionInfoResponse> => {
  return fetchProductCatNavFilters(
    createProductFirstFiltersRequest({
      navigationPath,
      filterKeys,
      requestReferrer,
    }),
    {
      signal,
    }
  );
};
